// extracted by mini-css-extract-plugin
export default {"container":"IF-z","disabled":"JF-z","bgBlack":"KF-z","content":"LF-z","countdown":"MF-z","topCaption":"NF-z","topHeading":"OF-z","heading":"PF-z","copy":"QF-z"};